import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type AddonDetails as SchemaAddonDetails } from '../schemas/AddonDetails';
import { type AddonUpdateCommand as SchemaAddonUpdateCommand } from '../schemas/AddonUpdateCommand';
import { type Error as SchemaError } from '../schemas/Error';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Addons
 * @summary Update addon
 */
export const UpdateAddonContentType = 'application/json' as const;
export type UpdateAddonRequest = SchemaAddonUpdateCommand;
export type UpdateAddonResponses = LinkCommonErrorResponses & {
    /**
     * @description Addon updated
     */
    '200': {
        'application/json': SchemaAddonDetails;
    };
    /**
     * @description Addon not found
     */
    '404': {
        'application/json': SchemaError;
    };
};
export type UpdateAddonResponseSuccess = UpdateAddonResponses['200']['application/json'];
export type UpdateAddonSearchParams = undefined;
export type UpdateAddonPathParameters = {
    id: string;
};
export const UpdateAddonUrl = '/addons/{id}' as const;
export const UpdateAddonMethod = 'PATCH' as const;
export const getUpdateAddonUrl = (params: UpdateAddonPathParameters) =>
    UpdateAddonUrl.replace(/\{(\w+)\}/g, (_match, param: keyof UpdateAddonPathParameters) => String(params[param]));
